// extracted by mini-css-extract-plugin
module.exports = {"itemChildTab":"RequestsProductionsPage_itemChildTab__rdOGS","btnTabs":"RequestsProductionsPage_btnTabs__uiQWu"};